import { ReportDailyResultImg } from "@/pages/common/report/WebReport2/commons";
import {
  Typography
} from "@mui/material";
import HelpButton from "../HelpButton";
import CriterionHelpDialogTableSections from "./commons/CriterionHelpDialogTableSections";


export default function RhythmCriterionHelpDialog() {
  return (
    <HelpButton
      dialogTitle="睡眠のリズムの判定基準"
      dialogProps={{ fullWidth: true }}
      iconSx={{
        height: "16px",
        width: "16px",
        color: "#A3A3A3",
        marginLeft: "4px",
      }}
    >
      <CriterionHelpDialogTableSections
        data={[
          {
            title: "日別判定の基準",
            table: {
              head: ["平均的な起床時刻からのズレ", "判定"],
              body: [
                {
                  label: "±2時間以内",
                  data: [[<ReportDailyResultImg type={3} />]],
                },
                {
                  label: "±2時間超",
                  data: [[<ReportDailyResultImg type={1} />]],
                },
              ],
            },
          },
          {
            title: "睡眠のリズム判定の基準",
            table: {
              head: [
                <Typography variant="subtitle2">
                  <ReportDailyResultImg type={3} style={{ paddingRight: 1 }} />
                  の日数
                </Typography>,
                <Typography variant="subtitle2">
                  <ReportDailyResultImg type={1} style={{ paddingRight: 1 }} />
                  の日数
                </Typography>,
                "判定",
              ],
              body: [
                {
                  label: "5日以上",
                  data: [
                    ["なし", "良好"],
                    ["1～2日", "注意"],
                  ],
                },
                {
                  label: "4日以下",
                  data: [
                    ["0～2日", "注意"],
                    ["3日以上", "警戒"],
                  ],
                },
              ],
            },
            remarks: [
              "※測定日数が7日間の場合",
              "※測定日数が3日以下の場合は判定不能",
            ],
          },
        ]}
      />
    </HelpButton>
  );
}
